<div class="detail-card">
  <div class="d-flex align-items-center gap-4 w-100">
    <div i18n class="detail-label flex-grow-1">Year-To-Date Payments</div>
    <div i18n class="detail-value">{{ yearToDatePayments | currency }}</div>
  </div>
</div>
